import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

export default class FormDialog extends React.Component {
    state = {
        value: '',
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { value } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={() => this.props.onClose(undefined)}
                aria-labelledby="form-dialog-title"
            >
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="value"
                        label={intl.formatMessage({ id: 'form_field_name_email' })}
                        type="email"
                        value={value}
                        onChange={this.handleChange}
                        name="value"
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.props.onClose(undefined)} color="primary">
                        {intl.formatMessage({ id: 'cancel' })}
                    </Button>
                    <Button onClick={() => this.props.onClose(value)} color="primary">
                        {intl.formatMessage({ id: 'accept' })}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/manage/template/DialogMail.js